import * as tslib_1 from "tslib";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
let RouteTabPane = class RouteTabPane extends Vue {
    constructor() {
        super(...arguments);
        this.show = true;
        this.currentName = this.name;
    }
    get contentStyle() {
        return {
            visibility: this.TabsInstance.activeKey !== this.currentName ? "hidden" : "visible",
        };
    }
    onNameChange(val) {
        this.currentName = val;
        this.TabsInstance.updateNav();
    }
    onLabelChange() {
        this.TabsInstance.updateNav();
    }
    onDisabledChange() {
        this.TabsInstance.updateNav();
    }
    mounted() {
        this.TabsInstance.updateNav();
    }
    destroyed() {
        this.TabsInstance.updateNav();
    }
};
tslib_1.__decorate([
    Prop(String)
], RouteTabPane.prototype, "name", void 0);
tslib_1.__decorate([
    Prop({
        type: String,
        default: "",
    })
], RouteTabPane.prototype, "label", void 0);
tslib_1.__decorate([
    Prop({
        type: Boolean,
        default: false,
    })
], RouteTabPane.prototype, "disabled", void 0);
tslib_1.__decorate([
    Prop({
        type: Boolean,
        default: null,
    })
], RouteTabPane.prototype, "closable", void 0);
tslib_1.__decorate([
    Prop(String)
], RouteTabPane.prototype, "tab", void 0);
tslib_1.__decorate([
    Prop(Number)
], RouteTabPane.prototype, "index", void 0);
tslib_1.__decorate([
    Inject()
], RouteTabPane.prototype, "TabsInstance", void 0);
tslib_1.__decorate([
    Watch("name")
], RouteTabPane.prototype, "onNameChange", null);
tslib_1.__decorate([
    Watch("label")
], RouteTabPane.prototype, "onLabelChange", null);
tslib_1.__decorate([
    Watch("disabled")
], RouteTabPane.prototype, "onDisabledChange", null);
RouteTabPane = tslib_1.__decorate([
    Component({
        name: "RouteTabPane",
    })
], RouteTabPane);
export default RouteTabPane;
